import { useMutation } from '@apollo/react-hooks';
import { kmsClient } from 'api';
import { SET_POST_MALONE_SAVED_TEMPLATE_CATEGORIES_MUTATION } from './setPostMaloneSavedTemplateCategories.mutation';
import {
  SetPostMaloneSavedTemplateCategoriesMutation,
  SetPostMaloneSavedTemplateCategoriesMutationVariables
} from './__generated__/SetPostMaloneSavedTemplateCategoriesMutation';

export const useSetPostMaloneSavedTemplateCategories = () => {
  return useMutation<
    SetPostMaloneSavedTemplateCategoriesMutation,
    SetPostMaloneSavedTemplateCategoriesMutationVariables
  >(SET_POST_MALONE_SAVED_TEMPLATE_CATEGORIES_MUTATION, { client: kmsClient });
};
